export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/encoderWorker.9783001f.worker.js");
}
